import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  DeleteButton,
  EditButton,
  List,
  Space,
  Table,
  useTable,
} from "@pankod/refine-antd";
// import {
//   // BooleanField,
//   DeleteButton,
//   EditButton,
//   IResourceComponentsProps,
//   List,
//   // ShowButton,
//   Space,
//   Table,
//   useTable,
// } from "@pankod/refine";
import { ISpecie } from "../../interfaces";

export const SpecieList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps } = useTable<ISpecie>({
    initialSorter: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  return (
    <List>
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="id" title="ID" />
        <Table.Column dataIndex="order" title="Order" />
        <Table.Column dataIndex="family" title="Family" />
        <Table.Column dataIndex={"name"} title="Specie" />
        <Table.Column<ISpecie>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              {/* <ShowButton size="small" hideText recordItemId={record.id} /> */}
              <EditButton size="small" hideText recordItemId={record.id} />
              <DeleteButton size="small" hideText recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
